// generated by genversion
export var version = '4.6.1';
//# sourceMappingURL=version.js.map